/* eslint-disable import/prefer-default-export */
import { takeLatest, put, call, all } from 'redux-saga/effects' // eslint-disable-line
import getAllSpecialitesActions, {
    getAllSpecialitesTypes,
} from '../../../redux/specialite/getAllSpecialites'
import getDisabledSpecialitesActions, {
    getDisabledSpecialitesTypes,
} from '../../../redux/specialite/getDisabledSpecialites'
import { Get } from '../../../serveur/axios'

function* getAllSpecialitesSagas({ response }) {
    const { enable, type } = response || {}
    let url = `/specialite/?enable=${enable || 'false'}`
    if (type) {
        url = `${url}&type=${type}`
    }
    try {
        const responseAdd = yield Get(url)
        if (responseAdd.status === 200) {
            if (enable === 'true')
                yield all([
                    yield put(
                        getDisabledSpecialitesActions.getDisabledSpecialitesSuccess(
                            responseAdd.data.data
                        )
                    ),
                ])
            else
                yield all([
                    yield put(
                        getAllSpecialitesActions.getAllSpecialitesSuccess(
                            responseAdd.data.data
                        )
                    ),
                ])
        } else if (enable === 'true')
            yield put(
                getDisabledSpecialitesActions.getDisabledSpecialitesFailure(
                    responseAdd.data
                )
            )
        else
            yield put(
                getAllSpecialitesActions.getAllSpecialitesFailure(
                    responseAdd.data
                )
            )
    } catch (error) {
        if (enable === 'true')
            yield put(
                getDisabledSpecialitesActions.getDisabledSpecialitesFailure(
                    error
                )
            )
        else yield put(getAllSpecialitesActions.getAllSpecialitesFailure(error))
    }
}

export function* getAllSpecialitesSaga() {
    yield takeLatest(
        getAllSpecialitesTypes.GET_ALL_SPECIALITES_REQUEST,
        getAllSpecialitesSagas
    )
    yield takeLatest(
        getDisabledSpecialitesTypes.GET_DISABLED_SPECIALITES_REQUEST,
        getAllSpecialitesSagas
    )
}
